import formComponent, { getUtmValue } from './form.js';

const getDefaultContactState = () => ({
    first_name: '',
    last_name: '',
    company: '',
    city: '',
    state: '',
    units: '',
    email: '',
    message: '',
    marketing_opt_in: false,
    utm_source: getUtmValue('utm_source'),
    utm_medium: getUtmValue('utm_medium'),
    utm_campaign: getUtmValue('utm_campaign'),
    utm_content: getUtmValue('utm_content'),
    conversion_page_url: window.location.href,
});

export default function contactsFormComponent() {
    return {
        // Initialize form handler with custom configuration
        ...formComponent({
            endpoint: '/actions/scp/form/submit',
            formHandle: 'general-contact',
            minSubmitTime: 3000,
            honeypotFieldName: 'website',
            onSuccess: (result) => {
            },
            onError: (error) => {
                console.error('Distributor form submission failed:', error);
            },
            beforeSubmit: function(payload) {
                return true;
            }
        }),

        // Component-specific properties
        contact: getDefaultContactState(),

        // Form submission handler
        async handleSubmit(event) {
            const formData = {
                contact: this.contact
            };
            await this.submit(event, formData);
        }
    };
}
